/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import classNames from "classnames";

const EventConfigIcon = ({ isActive = false, className = "" }) => {
  let fill;
  if (isActive === false) {
    fill = "#9a9a9a";
  } else {
    fill = "white";
  }

  return (
    <span className="flex items-center">
      <svg
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={classNames(className)}
      >
        <path
          d="M9.49321 15.7647L11.8824 13.943L14.2715 15.7647L13.3756 12.8081L15.7647 11.1059H12.838L11.8824 8L10.9267 11.1059H8L10.3891 12.8081L9.49321 15.7647Z"
          fill={fill}
        />

        <path
          d="M1.64712 14.352C1.25888 14.352 0.92641 14.2139 0.649704 13.9377C0.373469 13.661 0.235352 13.3285 0.235352 12.9403V3.0579C0.235352 2.66967 0.373469 2.33743 0.649704 2.0612C0.92641 1.78449 1.25888 1.64614 1.64712 1.64614H2.353V0.234375H3.76476V1.64614H9.41182V0.234375H10.8236V1.64614H11.5295C11.9177 1.64614 12.2502 1.78449 12.5269 2.0612C12.8031 2.33743 12.9412 2.66967 12.9412 3.0579V5.88143H1.64712V12.9403H6.58829V14.352H1.64712ZM1.64712 4.46967H11.5295V3.0579H1.64712V4.46967Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default EventConfigIcon;
